import React from 'react'
import classnames from 'classnames/bind'
import styles from './Card.module.css'

const cx = classnames.bind(styles)

export type CardVariant = 'default' | 'subtle' | 'hero'
export type CardPadding = 'sm' | 'md' | 'lg' | 'xl' | 'none'

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  variant?: CardVariant
  padding?: CardPadding
  as?: 'div' | 'section' | 'article'
  children: React.ReactNode
}

const paddingClassMap: Record<Exclude<CardPadding, 'none'>, string> = {
  sm: 'padding-sm',
  md: 'padding-md',
  lg: 'padding-lg',
  xl: 'padding-xl'
}

const Card: React.FC<CardProps> = ({
  variant = 'default',
  padding = 'md',
  as: Component = 'div',
  className,
  children,
  ...rest
}) => {
  return (
    <Component
      className={cx(
        'card',
        variant,
        padding !== 'none' && paddingClassMap[padding],
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  )
}

export default Card
